/**
 * Metadata about a user selected file that is safe to log.
 *
 * Useful for diagnosing platform specific upload failures. iOS in particular
 * can hand back files desktop browsers never produce: HEIC/HEIF images, `.mov`
 * live photos, and files with an empty `type`.
 */
export function describeFile(file: any) {
  if (file == null) {
    return null;
  }

  return {
    name: file.name ?? null,
    size: file.size ?? null,
    // iOS sometimes reports an empty string here.
    type: file.type || '(none)',
    extension: fileExtension(file.name),
    lastModified: file.lastModified ?? null,
    isFileInstance: typeof File !== 'undefined' && file instanceof File
  };
}

function fileExtension(name: any): string {
  const parts = String(name ?? '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : null;
}
